import { ComponentType } from "react";
import { Listing } from "../../types/listing";
import { PrintType } from "./useSearchListingsPage";

interface PrintRendererProps {
  printType: PrintType;
  listings: Listing[];
  PrintListViewComponentType: ComponentType<{ listing: Listing }>;
  PrintOneViewComponentType: ComponentType<{ listing: Listing }>;
}

export const PrintRenderer = ({
  printType,
  listings,
  PrintListViewComponentType,
  PrintOneViewComponentType,
}: PrintRendererProps) => {
  if (printType === PrintType.multiple) {
    return (
      <>
        {listings.filter((listing: Listing) => listing?.id).map((listing: Listing) => (
          <PrintListViewComponentType
            key={`print-list-view-${listing.id}`}
            listing={listing}
          />
        ))}
      </>
    );
  }

  if (printType === PrintType.single) {
    return (
      <>
        {listings.filter((listing: Listing) => listing?.id).map((listing: Listing) => (
          <PrintOneViewComponentType
            key={`print-one-view-${listing.id}`}
            listing={listing}
          />
        ))}
      </>
    );
  }

  return null;
};